import { searchApprovedDomains } from "@/api/approved-domain.service";
export const useQuoteAndApplySiteSearch = () => {
  return {
    itemTitle: i => i.domain,
    comparisonValue: v => v.id,
    fetchResults: v => searchApprovedDomains(v)
  };
};
